import { useSortable } from '@dnd-kit/sortable';
import type { ReactNode } from 'react';
import { CSS } from '@dnd-kit/utilities';
import { StyledSwitch } from 'components/inputs/Switch';
import { CheckboxWrapper } from './CheckboxWrapper';
import styled from '@emotion/styled';
import { Text } from 'components/text/Text';
import { ColumnSelectorItem } from '../../types';
import { trans } from 'features/misc/table/utils';

export const SortableItem = ({
  id,
  getIsVisible,
  getToggleVisibilityHandler,
  isDisabled,
  columnDef,
}: ColumnSelectorItem) => {
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  const headerText = () => {
    let text: string | ReactNode = id;
    try {
      if (typeof columnDef.header === 'string') {
        text = trans(columnDef.header);
      }
      if (typeof columnDef.header === 'function') {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        text = columnDef.header({});
      }
    } catch (error) {
      text = id;
    }
    return text;
  };

  return (
    <div ref={setNodeRef} style={style}>
      <CheckboxWrapper hasIcon={!isDisabled} attributes={attributes} listeners={listeners}>
        <StyledSwitch
          size="small"
          disabled={isDisabled}
          checked={getIsVisible()}
          onChange={getToggleVisibilityHandler()}
        />{' '}
        <Label variant="labelSm" isDisabled={isDisabled}>
          {headerText()}
        </Label>
      </CheckboxWrapper>
    </div>
  );
};

interface LabelProps {
  isDisabled?: boolean;
}

const Label = styled(Text)<LabelProps>`
  ${p => p.isDisabled && `color: ${p.theme.palette.text.disabled};`}
`;
